import { render, staticRenderFns } from "./TransportFormPage.vue?vue&type=template&id=0ffb8098&scoped=true"
import script from "./TransportFormPage.vue?vue&type=script&lang=js"
export * from "./TransportFormPage.vue?vue&type=script&lang=js"
import style0 from "./TransportFormPage.vue?vue&type=style&index=0&id=0ffb8098&prod&lang=scss&scoped=true"
import style1 from "./TransportFormPage.vue?vue&type=style&index=1&id=0ffb8098&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ffb8098",
  null
  
)

export default component.exports